import React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';

const Error = ({ error, warning, className }) => {
  return error || warning ? (
    <ErrorContainer className={className} error={error}>
      <p>{error || warning}</p>
    </ErrorContainer>
  ) : null;
};

const ErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2rem;

  & > p {
    color: ${({ theme, error }) =>
      error ? theme.status.error : theme.status.warning} !important;
    margin: 0 !important;
  }
`;

Error.displayName = 'Error';

Error.defaultProps = {
  error: '',
  className: '',
};

Error.propTypes = {
  /** string with errormessage */
  error: string,
  /** string with warningmessage */
  warning: string,
  className: string,
};

export const getBorderColor = (error, touched, theme, warning) => {
  if (error) return theme.status.error;
  else {
    if (warning) return theme.status.warning;
    else if (touched) return theme.status.succes;
  }
  return theme.ui.outline;
};

export default Error;
